import LoginService from "ips/ac/util/LoginService";
import { getChecklistItems } from '@etoundi1er/hugerte-checklist-plugin';

LoginService.getInstance().checkLogin();

initTinyMCE();


async function initTinyMCE() {
  const { default: tinymce } = await import("tinymce");
  window.tinymce = tinymce;

  import ("tinymce/plugins/lists");
  import ("tinymce/plugins/link");
  import ("tinymce/plugins/image");
  import ("tinymce/plugins/table");

  const { default: hugerte } = await import("hugerte");
  window.hugerte = hugerte;
}